// extracted by mini-css-extract-plugin
export default {"badge":"GameBadge_badge__+HY+K","name":"GameBadge_name__IjbNb"};